define('app/services/shared',['angular'], function (angular) {
  var module = angular.module('app.shared', [])

  module.factory('sharedProperties', ['$injector', 'apiRoot', function ($injector, apiRoot) {
    var apiBaseUrl = apiRoot
    var token = 'tockenapp'
    var apiBaseUrl = '/' // "http://localhost:8088/"; //"http://92.186.21.64:8090/"
    var baseUrl = 'http://localhost:8000/'

    /*
     var token = $('#oc_token').val()
     var apiBaseUrl = $('#api_baseUrl').val()
     var baseUrl = $('#base_url').val()
     */

    var serveis = {
      replaceTokens: function(toTranslate, obj) {
        //var obj = { x: {id:1, elem:{}}, resp: {Id:1} }
        //toTranslate = toTranslate.replace(/<([^>.]+)>|<([^>.]+).([^>.]+)>/gi, function myFunction(match,g1,g2,g3) {
        toTranslate = toTranslate.replace(/:([^:.]+):|:([^:.]+).([^:.]+):/gi, function myFunction(match,g1,g2,g3) {
          if (g2) { //<g2.g3>
            return obj[g2][g3];
          }
          return obj.x[g1]; //<g1>
        })
        //console.log(toTranslate, obj);
        return toTranslate;
      },
      getToken: function () {
        return token
      },
      setToken: function (value) {
        token = value
      },
      getApiBaseUrl: function () {
        return apiBaseUrl
      },
      setApiBaseUrl: function (value) {
        apiBaseUrl = value
      },
      getBaseUrl: function () {
        return baseUrl
      },
      setBaseUrl: function (value) {
        baseUrl = value
      },
      getErrorMessage: function(errorResponse) {
        console.log(errorResponse);
        if (!angular.isObject(errorResponse.data)) {
          if(!angular.isUndefined(errorResponse.statusText))
            return errorResponse.statusText;
          return errorResponse.status;
        }
        var obj = errorResponse.data.ResponseStatus;
        var text = obj.Message;
        if (obj.hasOwnProperty('Errors') && angular.isArray(obj.Errors) && obj.Errors.length > 1) {
          text = '';
          for (var i=0; i<obj.Errors.length; i++) {
            text += '<br>' + obj.Errors[i].Message;
          }
        }
        return text;
      }
    }
    return serveis
  }])

  module.factory('sharedUserProperties', ['$http', 'sharedProperties', function ($http, sharedProperties) {
    var serveis = {
      getUserInfo: function () {
        // var apiBaseUrl = sharedProperties.getApiBaseUrl()
        var token = sharedProperties.getToken()
        $http.defaults.headers.common['X-UAId'] = token

        /*
         return $http.get(apiBaseUrl + 'user/logged/').then(function(result) {
         if ('error' in result.data) {
         window.location = $('body').data('base-url')
         }
         return result.data
         })
         */
      }
    }
    return serveis
  }])

  module.factory('actionFactory', ['$http', 'sharedProperties', '$route', '$filter', '$location', '$interpolate', 'apiRoot', function ($http, sharedProperties, route, filter, location, interpolate, apiRoot) {
    var serveis = {
      updateItemActions: function (info, currentActions, idOrIds) {
        if (!info.actionsPerItem) return

        var ids = []
        if(angular.isArray(idOrIds)) {
          for (var i=0; i<idOrIds.length; i++) {
            ids.push(info.isInt ? parseInt(idOrIds[i]):idOrIds[i])
          }
        } else {
          ids.push(info.isInt ? parseInt(idOrIds):idOrIds)
        }

        // elimino de les estructures actuals l'id...
        angular.forEach(currentActions, function (value, key) {
          if (value.hasOwnProperty('ids')) {
            for (var ndxId = 0; ndxId < ids.length; ndxId++) {
              var id = ids[ndxId]
              var ndx = value.ids.indexOf(id)
              if (ndx >= 0) {
                value.ids.splice(ndx, 1)
              }
            }
            // console.log(value.name + "ids v2: " + value.ids)
          }
        }, currentActions)

        // Demano i actualitzo!
        var url = apiRoot + 'actions/' + info.keyType + '/' + info.name
        return $http.post(url, {
          Ids: ids
        }).then(function (actions) {
          angular.forEach(actions.data, function (value, key) {
            var elems = filter('filter')(this, {id: value.name}, true)
            if (elems.length === 1) {
              if (!elems[0].hasOwnProperty('ids')) {
                elems[0].ids = value.ids
              } else {
                angular.forEach(value.ids, function (idToInsert) {
                  elems[0].ids.push(idToInsert)
                })
              }
            }
          }, currentActions)
        })
      },
      complementActions: function (info, currentActions, idOrIds) {
        // complement es el mateix que update pero primer eliminem els ids.
        if (!info.actionsPerItem) return
        angular.forEach(currentActions, function (value, key) {
          if (value.hasOwnProperty('ids')) {
            delete value.ids
          }
        }, currentActions)

        return this.updateItemActions(info, currentActions, idOrIds)
/*
        var ids = []
        if(angular.isArray(idOrIds)) {
          for (var i=0; i<idOrIds.length; i++) {
            ids.push(info.isInt ? parseInt(idOrIds[i]):idOrIds[i])
          }
        } else {
          ids.push(info.isInt ? parseInt(idOrIds):idOrIds)
        }

        angular.forEach(currentActions, function (value, key) {
          if (value.hasOwnProperty('ids')) {
            delete value.ids
          }
        }, currentActions)

        var url = apiRoot + 'actions/' + info.keyType + '/' + info.name
        return $http.post(url, {
          Ids: ids
        }).then(function (actions) {
          // console.log(currentActions)
          angular.forEach(actions.data, function (value, key) {
            var elems = filter('filter')(this, {id: value.name}, true)
            if (elems.length === 1) {
              elems[0].ids = value.ids
            }
          }, currentActions)
          // console.log(currentActions)
        })*/
      }
    }
    return serveis
  }])

  return module
})
;
